import 'css-chunksrc/client/scenes/projectRemoval/styles.scss';export default {
  "header": "_header_1cicw_1",
  "group": "_group_1cicw_5",
  "text": "_text_1cicw_9",
  "count": "_count_1cicw_14",
  "main": "_main_1cicw_20",
  "buttons": "_buttons_1cicw_27"
};